var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmileLowIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.14 17.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e74c3c;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Smile-03") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.16,12.29a.69.69,0,0,1,0,.54.68.68,0,0,1-.41.35.7.7,0,0,1-.55,0,.68.68,0,0,1-.36-.42,2.85,2.85,0,0,0-5.45,0,.71.71,0,0,1-.88.47h0A.7.7,0,0,1,5,12.31v0a4.12,4.12,0,0,1,1.54-2.18,4.33,4.33,0,0,1,5.09,0A4.12,4.12,0,0,1,13.16,12.29ZM7.64,5.72A1.43,1.43,0,1,1,6.21,4.29,1.43,1.43,0,0,1,7.64,5.72Zm5.71,0a1.43,1.43,0,1,1-.42-1A1.43,1.43,0,0,1,13.36,5.72Zm2.86,2.86a6.94,6.94,0,0,0-.57-2.77A7.13,7.13,0,0,0,6.3,2a7.14,7.14,0,0,0-3.8,9.35,7.13,7.13,0,0,0,9.35,3.8,7,7,0,0,0,3.8-3.8A6.94,6.94,0,0,0,16.21,8.57Zm1.43,0a8.38,8.38,0,0,1-1.15,4.3A8.53,8.53,0,0,1,13.37,16a8.38,8.38,0,0,1-4.3,1.15A8.38,8.38,0,0,1,4.77,16a8.53,8.53,0,0,1-3.12-3.12A8.38,8.38,0,0,1,.5,8.57a8.38,8.38,0,0,1,1.15-4.3A8.53,8.53,0,0,1,4.77,1.15,8.39,8.39,0,0,1,9.07,0a8.38,8.38,0,0,1,4.3,1.15,8.53,8.53,0,0,1,3.12,3.12A8.39,8.39,0,0,1,17.64,8.57Z",
    transform: "translate(-0.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileLowIco);
export default __webpack_public_path__ + "static/media/smile-low-ico.a840a4450d5a8438d05fcc1718c3b208.svg";
export { ForwardRef as ReactComponent };